import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustNumbers from "./components/TrustNumbers";
import CategoryGrid from "./components/CategoryGrid";
import SeoContent from "./components/SeoContent";
import CTASection from "./components/CTASection";
import ArticleCards from "./components/ArticleCards";
import FAQSection from "./components/FAQSection";

const siteUrl = "https://allchinabuy.art";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${siteUrl}/#webpage`,
  "url": `${siteUrl}/`,
  "name": "Best AllChinaBuy Spreadsheet 2026 | Verified Finds & Guides",
  "description": "The #1 Community AllChinaBuy Spreadsheet Resource. Discover verified finds, QC guides, shipping tutorials and community recommendations updated weekly. Browse 10,000+ curated products.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@type": "WebSite",
    "@id": `${siteUrl}/#website`,
    "url": `${siteUrl}/`,
    "name": "allchinabuy.art",
    "description": "Community-driven AllChinaBuy Spreadsheet resource with verified finds and shopping guides.",
    "publisher": {
      "@type": "Organization",
      "name": "allchinabuy.art",
      "url": `${siteUrl}/`
    }
  },
  "about": {
    "@type": "Thing",
    "name": "AllChinaBuy Spreadsheet",
    "description": "A community-curated database of verified product finds, seller links, QC references, and shopping guides."
  },
  "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg"
  },
  "dateModified": "2026-06-25"
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustNumbers />
        <CategoryGrid />
        <SeoContent />
        <ArticleCards />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}